module.exports = __webpack_public_path__ + "img/logo printstat cloud.b92be03c.png";